import { render, staticRenderFns } from "./contractTemplateEditor.vue?vue&type=template&id=585e88b6&scoped=true"
import script from "./contractTemplateEditor.vue?vue&type=script&lang=js"
export * from "./contractTemplateEditor.vue?vue&type=script&lang=js"
import style0 from "./contractTemplateEditor.vue?vue&type=style&index=0&id=585e88b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585e88b6",
  null
  
)

export default component.exports